import { render, staticRenderFns } from "./FormWizardIndex.vue?vue&type=template&id=d932b932"
import script from "./FormWizardIndex.vue?vue&type=script&lang=js"
export * from "./FormWizardIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports